import React from 'react';
import FormInvalid from './FormInvalid';
import { dusk } from '../../../utils/helpers';

function CustomControlCheckbox({ field, value, label, error, handleChange, isDisabled = false }) {
    function hasError() {
        return !!error;
    }

    function renderError() {
        if (hasError()) {
            return <FormInvalid message={error} />;
        }
    }

    return (
        <div className='custom-control custom-checkbox mr-sm-2 mb-3'>
            <input
                disabled={isDisabled}
                type='checkbox'
                id={field}
                className={`custom-control-input ${hasError() ? 'is-invalid' : ''}`}
                name={field}
                checked={value}
                onChange={handleChange}
            />
            {/* eslint-disable-next-line react/jsx-props-no-spreading */}
            <label className='custom-control-label' {...dusk('checkbox-' + field)} htmlFor={field}>
                {label}
            </label>
            {renderError()}
        </div>
    );
}

export default CustomControlCheckbox;
